import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../reduxToolkit/hooks';
import './PlatformPauseNotice.scss';

const PlatformPauseNotice = () => {
  const { t } = useTranslation();
  const { isAuthenticated, id } = useAppSelector((state) => state.auth);
  const noticeRef = useRef<HTMLDivElement>(null);
  const exemptIds = process.env.REACT_APP_PAUSE_NOTICE_EXEMPT_USER_ID
    ?.split(',')
    .map((value) => value.trim());

  const showNotice = isAuthenticated &&
    id != null &&
    !!exemptIds?.length &&
    exemptIds.every((value) => /^\d+$/.test(value)) &&
    !exemptIds.includes(String(id));

  useEffect(() => {
    if (!showNotice || !noticeRef.current) return;

    const notice = noticeRef.current;
    const syncHeight = () => {
      document.documentElement.style.setProperty(
        '--platform-pause-notice-height',
        `${Math.ceil(notice.getBoundingClientRect().height)}px`,
      );
    };

    syncHeight();
    const observer = new ResizeObserver(syncHeight);
    observer.observe(notice);
    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty('--platform-pause-notice-height');
    };
  }, [showNotice]);

  if (!showNotice) return null;

  return (
    <div ref={noticeRef} className="platform-pause-notice" role="status">
      <span className="platform-pause-notice__icon" aria-hidden="true">⚠</span>
      <span className="platform-pause-notice__text">{t('platformPause.notice')}</span>
    </div>
  );
};

export default PlatformPauseNotice;
